import EmployeeLogsPageView from "./EmployeeLogsPageView";

function EmployeeLogsPage() {
  return <EmployeeLogsPageView />;
}

export default EmployeeLogsPage;
